<script setup>
import DpExpand from './DpExpand';
import DpIcon from './DpIcon';
import { ref } from 'vue';

const props = defineProps({
  title: { type: String, default: '' }
});
const isOpen = ref(true);
</script>

<script>
export default {
  name: "DpListGroup"
}
</script>

<template>
  <div>
    <h3 @click="isOpen = !isOpen" class="dp-list-group__group-title">
      <DpIcon icon="chevron-inline-end" :class="['dp-list-group__title-icon', {'is-open': isOpen}]"/>
      <slot name="title">{{ props.title }}</slot>
    </h3>
    <DpExpand>
      <div v-show="isOpen">
        <slot></slot>
      </div>
    </DpExpand>
  </div>
</template>

<style lang="scss">
.dp-list-group__group-title {
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  color: var(--use-theme__ui-gradient-5);
  cursor: pointer;
}

.dp-list-group__title-icon {
  margin-inline-end: .25em;
  display: inline-block;
  transition-duration: 250ms;

  &.is-open {
    transform: rotate(90deg);
  }
}
</style>

<i18n>
{}
</i18n>
